import { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  group: { display: 'inline-flex', gap: 2 },
  btn: {
    border: 0,
    background: 'none',
    font: 'inherit',
    fontSize: 12,
    fontWeight: 500,
    color: 'var(--bui-fg-secondary)',
    padding: '3px 8px 4px',
    borderBottom: '2px solid transparent',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': { color: 'var(--bui-fg-primary)' },
  },
  active: {
    color: 'var(--bui-fg-primary)',
    fontWeight: 600,
    borderBottomColor: 'var(--bui-bg-solid)',
  },
  mono: {
    fontFamily: 'var(--bui-font-monospace)',
    maxWidth: 190,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const QuietToggle = ({
  pressed,
  onPress,
  mono,
  title,
  children,
}: {
  pressed: boolean;
  onPress: () => void;
  mono?: boolean;
  title?: string;
  children: ReactNode;
}) => {
  const classes = useStyles();
  return (
    <button
      type="button"
      title={title}
      aria-pressed={pressed}
      className={`${classes.btn}${mono ? ` ${classes.mono}` : ''}${
        pressed ? ` ${classes.active}` : ''
      }`}
      onClick={onPress}
    >
      {children}
    </button>
  );
};

export const QuietToggleGroup = ({
  label,
  options,
  value,
  onChange,
  mono,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (next: string) => void;
  mono?: boolean;
}) => {
  const classes = useStyles();
  return (
    <span className={classes.group} role="group" aria-label={label}>
      {options.map(o => (
        <QuietToggle
          key={o}
          title={o}
          mono={mono}
          pressed={o === value}
          onPress={() => onChange(o)}
        >
          {o}
        </QuietToggle>
      ))}
    </span>
  );
};
